// export const data = [
//   {
//     id: "dfa",
//     files: [
//       "नागरिकता प्रमाणपत्रको प्रतिलिपि",
//       "जन्म दर्ता प्रमाणपत्रको प्रतिलिपि",
//       //not required
//     ],
//     name: "Aaaa", //required
//     values: [
//       {
//         id: 1,
//         key: "Heading",
//         isStatic: true, //
//         data: "<h1>This is Heading</h1>",
//         dataType: "html" || "json" || "string",
//         logo: "https://e7.pngegg.com/pngimages/397/510/png-clipart-graphic-design-logo-online-and-offline-business-design-company-text.png",
//       },
//       {
//         key: "Date",
//         isStatic: false,
//         data: "",
//         dataType: "string",
//         //required
//       },
//       {
//         key: "Subject",
//         isStatic: false,
//         data: "",
//         dataType: "string",
//         placeholder: "Enter subject",
//         // required
//       },
//       {
//         key: "Paragraph",
//         isStatic: false, // has inputs or not (need to process or not)
//         data: "<p  class='paragraph'>Your name is <span id='text1'></span> and age is <span id='number1'></span> and gender <span id='select1'></span>And your date of birth is <span id='date1'></span>. Hello</p>", // we render this, text1 number2
//         dataType: "html",
//         fields: {
//           text1: {
//             type: "text",
//             placeholder: "Name",
//           },
//           number1: {
//             type: "number",
//             placeholder: 23,
//           },
//           select1: {
//             type: "select",
//             options: [
//               { key: "male", value: "male" },
//               { key: "female", value: "female" },
//             ],
//           },
//           date1: {
//             type: "date",
//             placeholder: "----/--/--",
//           },
//         },
//       },

//       {
//         key: "HorizontalLine",
//         isStatic: true,
//         data: "<hr class='bg-danger' style='border-top:2px solid red;'/>",
//       },
//       {
//         key: "Table",
//         isStatic: false,
//         data: {
//           headings: [
//             {
//               name: " sn",
//               type: "number",
//             },
//             {
//               name: "name",
//               type: "text",
//             },
//             {
//               name: "age",
//               type: "number",
//             },
//           ],
//           minRow: "2",
//           maxRow: "5",
//         },
//       },

//       {
//         key: "Logo",
//         isStatic: true,
//         data: "https://e7.pngegg.com/pngimages/397/510/png-clipart-graphic-design-logo-online-and-offline-business-design-company-text.png",
//       },
//       {
//         key: "FingerPrint",
//         isStatic: true,
//       },
//       {
//         key: "Signature",
//         isStatic: true,
//         data: "html",
//         dataType: "html",
//       },
// {
//   key: "HorizontalLine",
//   isStatic: true,
//   data: "<hr class='bg-danger' style='border-top:2px solid red;'/>",
// },
// {
//   key: "Table",
//   isStatic: false,
//   data: {
//     headings: [
//       {
//         name: " sn",
//         type: "number",
//       },
//       {
//         name: "name",
//         type: "text",
//       },
//       {
//         name: "age",
//         type: "number",
//       },
//     ],
//     minRow: "2",
//     maxRow: "5",
//   },
// },

// {
//   key: "Logo",
//   isStatic: true,
//   data: "https://e7.pngegg.com/pngimages/397/510/png-clipart-graphic-design-logo-online-and-offline-business-design-company-text.png",
// },
// {
//   key: "Photo",
//   isStatic: true,
//   imgSrc:
//     "https://e7.pngegg.com/pngimages/397/510/png-clipart-graphic-design-logo-online-and-offline-business-design-company-text.png",
// },
// {
//   key: "Partition",
//   isStatic: true,
//   parts: [
//     {
//       key: "FingerPrint",
//       isStatic: true,
//       styles: {
//         float: "left",
//       },
//     },
//     {
//       key: "Paragraph",
//       isStatic: false, // has inputs or not (need to process or not)
//       data: "<p  class='paragraph'>Your name is <span id='text1'></span> and age is <span id='number1'></span> and gender <span id='select1'></span>And your date of birth is <span id='date1'></span>. Hello</p>", // we render this, text1 number2
//       dataType: "html",
//       fields: {
//         text1: {
//           type: "text",
//           placeholder: "Name",
//         },
//         number1: {
//           type: "number",
//           placeholder: 23,
//         },
//         select1: {
//           type: "select",
//           options: [
//             { key: "male", value: "male" },
//             { key: "female", value: "female" },
//           ],
//         },
//         date1: {
//           type: "date",
//           placeholder: "----/--/--",
//         },
//       },
//     },
//     {
//       key: "Signature",
//       isStatic: true,
//       data: "html",
//       dataType: "html",
//     },
// {
//   key: "TextInput",
//   isStatic: false,
//   data: '<p>श्रीमान प्रमुख जिल्ला अधिकारीज्यू<br/><span id="select1"></span>',
//   dataType: "html",

//   fields: {
//     select1: {
//       type: "text",
//       placeholder: "Name",
//     },
//   },
// },
//   ],
// },
//     ],
//   },
// ];

// const value = {
//   template: "1",
//   files: [],
//   name: "",

//   // data: {
//   //   "Paragraph-3243": {},
//   // },
//   data: [{ filedName: "Paragraph-3243", value: {} }],
// };

export const data = [
  {
    id: "0",
    files: [
      "नागरिकता प्रमाणपत्रको प्रतिलिपि",
      "जन्म दर्ता प्रमाणपत्रको प्रतिलिपि",
      //not required
    ],
    name: "नागरिकताको प्रतिलिपी सिफारिस", //required
    config: {
      isNewFormat: true,
    },
    preview: `<div class="col-md-12 respect"> <div class="row"> <div class="col-md-6"> <p> श्री अध्यक्ष ज्यू<br/>  {{}} नगरपालिका कार्यालय<br/> <p> {{number1}}  नं. कार्यालय {{}} बर्दिया </p><br/> <p> {{}} नं. प्रदेश, नेपाल </p><br/> </p></div><div class="col-md-6 d-flex justify-content-end"> मिति : {{date1}} </div></div><h5 style="text-align: center;"><strong>विषय:&nbsp;<u>नेपाली नागरिकताको प्रतिलिपी सिफारिस गरी पाउँ।</u></strong></h5></div><div class="col-md-12 respect"> <p>महोदय,</p></div><div class="col-md-12 respect"> <p>उपरोक्त सम्बन्धमा निबेदन गर्नको कारण यो छ की मैले जिल्ला प्रशासन कार्यलय {{}} बाट मिति {{date2}} मा प्राप्त गरेको ना. प्र. नं. {{num1}} नेपाली नागरिकता {{select1}} हुँदा निम्न अनुसार विवरण खुलाई नेपाली नागरिकताको नागरिकताको प्रतिलिपी सिफारिस गरि पाउनको लागि सादर अनुरोध गर्दछु । </p></div><h5 align="center"><u>निम्न विवरण</u></h5><div class="m-4"> <div class="row w-100 mb-4"> <div class='col-12'> नाम थर :- {{name1}} </div></div><div class="row w-100 mb-4"> <div class='col-12'> जन्म स्थान :- {{text1}} </div></div><div class="row w-100 mb-4"> <div class="col-md-12"> जन्म मिति (बि.सं) :- {{date3}} </div></div><div class="row w-100 mb-4"> <div class="col-12"> स्थायी वतन :- {{text2}} </div></div><div class="row w-100 mb-4"> <div class="col-12"> पिताको नाम थर:- {{text3}} </div></div><div class="row w-100 mb-4"> <div class="col-12"> आमाको नाम थर:- {{text4}} </div></div><div class="row w-100 mb-4"> <div class="col-12"> पतिको नाम थर:- {{text5}} </div></div><div class="row w-100 mb-4"> <div class="col-12"> नागरिकताको किसिम:- {{select2}} </div></div><div class="row m-4"> <div class="col-6"> <table style="border-color: transparent; margin: 8px;" border="1" cellpadding="5"> <tbody> <tr> <th style="border: solid 1px #000;">दायाँ</th> <th style="border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000;">बायाँ</th> </tr><tr> <td style="border: solid 1px #000; width: 88px; height: 88px;" height="88px">&nbsp;</td><td style="border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000; width: 88px; height: 88px;" height="88px">&nbsp;</td></tr></tbody> </table> </div><div class="col-6"> <p><strong>निबेदक</strong>,<br/>नाम/थर :- {{name1}} <br/> ठेगाना :- {{text9}} <br/> सही छाप :- <br/> मिति :- {{date1}} </p></div></div></div>`,
    data: {},
    values: [
      {
        key: "FormGroup",
        id: "1",
        title: "",
        backgroundColor: "",
        border: "",
        // options: [
        //   { key: "1", value: "1" },
        //   { key: "2", value: "2" },
        // ],
        row: [
          [
            {
              key: "Date",
              language: "nepali",
              label: "आजको मिति",
              id: "date1",
            },
            {
              key: "Date",
              language: "nepali",
              label: "नागरिकता जारी मिति",
              id: "date2",
            },
          ],
          [
            {
              key: "Select",
              language: "nepali",
              label: "कारण",
              id: "select1",
              options: {
                1: "झुत्रो भएको",
                2: "हराएको",
                3: "नया ढाँचाको आवश्यक भएको",
              },
            },
          ],
          [
            {
              key: "Number",
              language: "nepali",
              label: "नागरिकता नं.",
              id: "num1",
            },
            {
              key: "Select",
              language: "nepali",
              label: "नागरिकताको किसिम",
              id: "select2",
              options: {
                1: "वंशज",
                2: "जन्मको आधार",
                3: "वैवाहिक अंगीकृत",
                4: "जन्म सिद्ध",
              },
            },
          ],
        ],
      },
      {
        key: "FormGroup",
        id: "2",
        title: "व्यक्तिगत विवरण",
        backgroundColor: "",
        border: "",
        row: [
          [{ key: "Name", language: "nepali", id: "name1" }],
          [
            {
              key: "Date",
              id: "date3",
              language: "nepali",
              label: "जन्म मिति (बि.सं)",
            },
            {
              key: "Text",
              language: "nepali",
              id: "text1",
              label: "जन्म स्थान",
            },
          ],
          [
            {
              key: "Text",
              language: "nepali",
              id: "text2",
              label: "स्थायी वतन ",
            },
            {
              key: "Text",
              language: "nepali",
              label: "ठेगाना",
              id: "text9",
            },
          ],
        ],
      },
      {
        key: "FormGroup",
        id: "4",
        title: "पारिवारिक विवरण",
        row: [
          [
            {
              key: "Text",
              language: "nepali",
              id: "text3",
              label: "पिताको नाम थर",
            },
          ],
          [
            {
              key: "Text",
              language: "nepali",
              id: "text4",
              label: "आमाको नाम थर",
            },
          ],
          [
            {
              key: "Text",
              language: "nepali",
              id: "text5",
              label: "पतिको नाम थर",
            },
          ],
        ],
      },
    ],
  },
  {
    id: "1",
    files: [
      "नागरिकता प्रमाणपत्रको प्रतिलिपि",
      "जन्म दर्ता प्रमाणपत्रको प्रतिलिपि",
      //not required
    ],
    name: "Anusuchi(Front)", //required
    config: {
      isNewFormat: true,
    },
    preview: `<div class="col-md-12 respect"> <p class="text-center"><strong>अनुसूची-१</strong></p><p class=''> नियम (३) को उपनियम (१) र (३), नियम ४ को उपनियम (१) र नियम १६ को उपनियम (१) सँग सम्बन्धित </p><br/> <p>श्री&nbsp;प्रमुख जिल्ला अधिकारीज्यू<br/> {{select1}} प्रशासन कार्यालय, {{text21}}।</p><h5 style="text-align: center;"><strong>विषय:&nbsp;<u>नेपाली नागरिकताको प्रमाण-पत्र पाउँ ।</u></strong></h5></div><div class="col-md-12 respect"> <p>महोदय,</p></div><div class="col-md-12 respect"> <p>म वंशजको{{select1}}आधारले नेपाली नागरिक भएकोले देहायको विवरण खोली नेपाली नागरिकताको प्रमाण-पत्र पाउनकोलागि सिफारिस साथ रु. १०/- को टिकट टाँसी यो निवेदन पत्र पेश गरेको छु । मैले यस अधि नेपाली नागरिकताको प्रमाण-पत्र लिएकोछैन।</p></div><div class="row w-100"> <div class="col-6" style='border: 1px solid black;'> <div> <div class="row"> <div class="col-12"> १. नाम थर :-{{name1}}</div><div class="col-12"> FULL NAME (IN BLOCK) :-{{name2}}</div></div><div class="row"> <div class="col-6"> २. लिङ्ग :-{{select2}}  </div><div class="col-6"> Sex :-{{select3}}</div></div><div class="row"> <div class="col-12"> ३. जन्म स्थान :-{{text1}}</div><div class="col-12"> Place of Birth (in block) :-{{text2}}</div></div><div class="row"> <div class="col-12"> ४. स्थायी ठेगाना:- जिल्ला{{text3}},{{text4}}, वडा नं.{{num1}}</div><div class="col-12"> Permanent Address:- district{{text5}},{{text6}}, ward no.{{num2}}</div></div><div class="row"> <div class="col-12"> ५. जन्म मिति :-{{date2}}</div><div class="col-12"> <div>(शैक्षिक प्रमाण पत्र हुनेले सोही मिति उल्लेख गर्ने)</div><div>Date of birth :-{{date3}}</div></div></div></div></div><div class="col-6" style='border: 1px solid black;'> <div> <div class="row"> <div class="col-12"> बाबुको नाम, थर :-{{text7}}</div></div><div class="row"> <div class="col-6"> ठेगाना :-{{text8}}  </div><div class="col-6"> नागरिकता नं. :-{{num3}}</div></div><div class="row"> <div class="col-12"> नागरिकता जारी मिति र जिल् :-{{date4}},{{text9}}</div></div><div class="row"> <div class="col-12"> आमाको नाम,थर :-{{text10}}</div></div><div class="row"> <div class="col-12"> ठेगाना :-{{text11}}</div></div><div class="row"> <div class="col-12"> नागरिकता नं. :-{{num4}}</div></div><div class="row"> <div class="col-12"> नागरिकता जारी मिति र जिल् :-{{date5}},{{text12}}</div></div><div class="row"> <div class="col-12"> पति पत्नीका नामथर :-{{text13}}</div></div><div class="row"> <div class="col-12"> ठेगाना :-{{text14}}</div></div><div class="row"> <div class="col-12"> नागरिकता नं. :-{{num5}}</div></div><div class="row"> <div class="col-12"> नागरिकता जारी मिति र जिल् :-{{date6}},{{text15}}</div></div><div class="row"> <div class="col-12"> संरक्षकको नाम,थर :-{{text16}}</div></div><div class="row"> <div class="col-12"> ठेगाना :-{{text17}}</div></div><div class="row"> <div class="col-12"> नागरिकता नं. :-{{num6}}</div></div><div class="row"> <div class="col-12"> नागरिकता जारी मिति र जिल् :-{{date7}},{{text18}}</div></div></div></div></div><div class="row m-2 w-100"> <div class="col-12"> <p class="text-left"> मैले माथि लेखिदिएको व्यहोरा ठीक साँचो हो मपुठ्ठा ठहरे कानून बमोजिम सहुँला बुझाउँला। </p></div></div><div class="row my-2 w-100"> <div class="col-md-6"> <table style="border-color: transparent; margin: 8px;" border="1" cellpadding="5"> <tbody> <tr> <th style="text-align: center;" colspan="2">औंठा छाप</th> </tr></tbody> <tbody> <tr> <th style="border: solid 1px #000;">दायाँ</th> <th style="border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000;">बायाँ</th> </tr><tr> <td style="border: solid 1px #000; width: 88px; height: 88px;" height="88px">&nbsp;</td><td style="border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000; width: 88px; height: 88px;" height="88px">&nbsp;</td></tr></tbody> </table> </div><div class="col-md-6"> <p><strong>भवदिय</strong>, <br/>निवेदकको दस्तखत :-...................... <br/>मिति :-{{date4}}</p></div></div><div> <div style="text-decoration: underline;" class="text-center"> <strong>बाँसगढी नगरपालिकाको सिफारिस</strong> </div></div><div class="row m-2 w-100"> <div class="col-md-12 written">{{text16}}{{select10}}वडा नं.{{number9}}बाँके मा मिति:{{date5}}मा जन्म भई हाल बाँसगढी नगरपालिका वडा नं.{{number10}}मा स्थायी रुपमाबसोबास गरी आएका यसमा लेखिएका श्रीमान् श्रीमती{{text17}}बुढा को{{select11}}वर्ष{{number11}}को{{select12}}{{text18}}लाई म राम्ररी चिन्दछु । उपयुक्त लेखिए बमोजिमको निजको व्यहोरा मैले जाने बुझेसम्म साँचो हो । निजला{{select13}}आधारले नागरिकताको प्रमाण-पत्र दिए हुन्छ । उत्त विवरण भुठा ठहरे कानून बमोजिम सहुँला बुझाउँला । </div><div class="row w-100 m-3"> <div class="col-md-6"> <p><u> सिफारिस गर्ने </u> </p><div>मिति :-{{date5}}</div><div>कार्यालयको नाम र छाप:- ............ </div></div><div class="col-md-6"> <p>दस्तखत:-</p><p>नाम/थर :- ...........</p><p>पद :- ............</p></div></div></div></div>`,
    data: {},
    values: [
      {
        key: "FormGroup",
        id: "1",
        title: "",
        backgroundColor: "",
        border: "",
        // options: [
        //   { key: "1", value: "1" },
        //   { key: "2", value: "2" },
        // ],
        row: [
          [
            {
              key: "Select",
              language: "nepali",
              label: "आधार",
              id: "select1",
              options: {
                1: "नाताले",
                2: "जन्मका",
              },
            },
            {
              key: "Date",
              language: "nepali",
              label: "मिति",
              id: "date1",
            },
          ],
        ],
      },
      {
        key: "FormGroup",
        id: "2",
        title: "व्यक्तिगत विवरण",
        backgroundColor: "",
        border: "",
        row: [
          [
            { key: "Name", language: "nepali", id: "name1" },
            { key: "Name", language: "english", id: "name2" },
          ],
          [
            {
              key: "Date",
              id: "date2",
              language: "nepali",
              label: "जन्म मिति (बि.सं)",
            },
            {
              key: "Date",
              id: "date3",
              language: "english",
              label: "Date of birth (A.D)",
            },
          ],
          [
            {
              key: "Select",
              language: "nepali",
              label: "लिङ्ग",
              id: "select2",
              options: {
                "": "---लिङ्ग छान्नुहोस्---",
                1: "male",
                2: "female",
                3: "other",
              },
            },
            {
              key: "Select",
              language: "english",
              label: "Gender",
              id: "select3",
              options: {
                "": "---Select gender---",
                1: "male",
                2: "female",
                3: "other",
              },
            },
          ],
        ],
      },
      {
        key: "FormGroup",
        id: "3",
        title: "जन्मेको ठेगाना",
        backgroundColor: "",
        border: "",
        // options: [
        //   { key: "1", value: "1" },
        //   { key: "2", value: "2" },
        // ],
        row: [
          [
            {
              key: "Text",
              language: "nepali",
              id: "text1",
              label: "जन्म स्थान",
            },
            {
              key: "Text",
              language: "english",
              id: "text2",
              label: "Place of Birth (in block)",
            },
          ],
          [
            {
              key: "FormGroup",
              id: "2",
              title: "स्थायी बासस्थान",
              noBorder: true,
              row: [
                [
                  {
                    key: "Text",
                    language: "nepali",
                    id: "text3",
                    label: "जिल्ला",
                  },
                  {
                    key: "Text",
                    language: "nepali",
                    id: "text4",
                    label: "",
                  },
                  {
                    key: "Number",
                    language: "nepali",
                    id: "num1",
                    label: "वडा नं.",
                  },
                ],
              ],
            },
          ],
          [
            {
              key: "FormGroup",
              id: "4",
              title: "Permanent Address",
              noBorder: true,
              row: [
                [
                  {
                    key: "Text",
                    language: "english",
                    id: "text5",
                    label: "District",
                  },
                  {
                    key: "Text",
                    language: "english",
                    id: "text6",
                    label: "",
                  },
                  {
                    key: "Number",
                    language: "english",
                    id: "num2",
                    label: "Ward no",
                  },
                ],
              ],
            },
          ],
        ],
      },
      {
        key: "FormGroup",
        id: "4",
        title: "पारिवारिक विवरण",
        row: [
          [
            {
              key: "Text",
              language: "nepali",
              id: "text7",
              label: "बाबुको नाम, थर",
            },
            {
              key: "Text",
              language: "nepali",
              id: "text8",
              label: "ठेगाना",
            },
          ],
          [
            {
              key: "Number",
              language: "nepali",
              label: "नागरिकता नं",
              id: "num3",
            },
            {
              key: "Date",
              language: "nepali",
              label: "नागरिकता जारी मिति ",
              id: "date4",
            },
            {
              key: "Text",
              language: "nepali",
              label: "नागरिकता जारी जिल् ",
              id: "text9",
            },
          ],
          [
            {
              key: "Text",
              language: "nepali",
              id: "text10",
              label: "आमाको नाम, थर",
            },
            {
              key: "Text",
              language: "nepali",
              id: "text11",
              label: "ठेगाना",
            },
          ],
          [
            {
              key: "Number",
              language: "nepali",
              label: "नागरिकता नं",
              id: "num4",
            },
            {
              key: "Date",
              language: "nepali",
              label: "नागरिकता जारी मिति ",
              id: "date5",
            },
            {
              key: "Text",
              language: "nepali",
              label: "नागरिकता जारी जिल् ",
              id: "text12",
            },
          ],
          [
            {
              key: "Text",
              language: "nepali",
              id: "text13",
              label: "पति/पत्नीका नाम, थर",
            },
            {
              key: "Text",
              language: "nepali",
              id: "text14",
              label: "ठेगाना",
            },
          ],
          [
            {
              key: "Number",
              language: "nepali",
              label: "नागरिकता नं",
              id: "num5",
            },
            {
              key: "Date",
              language: "nepali",
              label: "नागरिकता जारी मिति ",
              id: "date6",
            },
            {
              key: "Text",
              language: "nepali",
              label: "नागरिकता जारी जिल् ",
              id: "text15",
            },
          ],
          [
            {
              key: "Text",
              language: "nepali",
              id: "text16",
              label: "संरक्षकको नाम, थर",
            },
            {
              key: "Text",
              language: "nepali",
              id: "text17",
              label: "ठेगाना",
            },
          ],
          [
            {
              key: "Number",
              language: "nepali",
              label: "नागरिकता नं",
              id: "num6",
            },
            {
              key: "Date",
              language: "nepali",
              label: "नागरिकता जारी मिति ",
              id: "date7",
            },
            {
              key: "Text",
              language: "nepali",
              label: "नागरिकता जारी जिल् ",
              id: "text18",
            },
          ],
        ],
      },
    ],
  },
  {
    id: "2",
    files: [
      "नागरिकता प्रमाणपत्रको प्रतिलिपि",
      "जन्म दर्ता प्रमाणपत्रको प्रतिलिपि",
      //not required
    ],
    name: "Citizenship Certificate Recommendation", //required
    config: {
      isNewFormat: true,
    },
    preview: `<div class="col-md-12 respect"> <p>श्रीमान&nbsp;प्रमुख जिल्ला अधिकारीज्यू<br/>{{select1}}प्रशासन कार्यालय<br/>{{text1}}।</p><h3 style="text-align: center;"><strong>विषय:&nbsp;<u>नेपाली नागरिकताको प्रमाण-पत्र प्रतिलिपि पाऊँ।</u></strong></h3></div><div class="col-md-12 respect"> <p>महोदय,</p></div><div class="col-md-12 respect"><p>मैले माईजोगमाई गाउँपालिका कार्यालयबाट देहायको विवरण भएको नेपाली नागरिकता प्रमाण-पत्र लिएकोमा सो प्रमाण-पत्रको सक्कल{{select2}}हुँदा सोको प्रतिलिपि पाउनको लागि सो नागरिकता प्रमाण-पत्रको प्रति संलग्न राखि रु. १३ (तेह्र) को टिकट टाँसी सिफारिस सहित यो निवेदन पेश गरेको छु।</p></div><h4 align="center">मैले नागरिकताको प्रमाण-पत्र लिदाको यस प्रकार छ ।</h4><div style="margin: 10px;border: 1px solid black; width: 100%; padding: 8px" border="1"> <div class="row w-100"> <div class="col-md-4 col-sm-6"> १. ना प्र प नं. :-{{num1}}</div><div class="col-md-4 col-sm-6"> मिति :-{{date1}}</div><div class="col-md-4 col-sm-12"> किसिम :-{{select2}}</div></div><div class="row w-100"> <div class='col-12'> २. नाम थर :-{{name1}}</div></div><div class="row w-100"> <div class='col-12'> FULL NAME (IN BLOCK) :-{{name2}}</div></div><div class="row w-100"> <div class="col-md-6"> ३. लिङ्ग :-{{select3}}  </div><div class="col-md-6"> Sex :-{{select4}}</div></div><div class="row w-100"> <div class='col-12'> ४. जन्म स्थान :-{{text1}}</div></div><div class="row w-100"> <div class='col-12'> Place of Birth (in block) :-{{text2}}</div></div><div class="row w-100"> <div class="col-12"> ५. स्थायी बासस्थान: </div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> जिल्ला :-{{text3}}</div><div class="col-md-4 col-sm-6">{{text4}}</div><div class="col-md-4 col-sm-12"> वडा नं. :-{{num2}}</div></div><div class="row w-100"> <div class="col-12"> Permanent Address:- </div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> District :-{{text5}}</div><div class="col-md-4 col-sm-6">{{text6}}</div><div class="col-md-4 col-sm-12"> Ward no :-{{num3}}</div></div><div class="row w-100"> <div class="col-md-6"> ६. जन्म मिति (बि.सं) :-{{date2}}</div><div class="col-md-6"> Date of birth (A.D) :-{{date3}}</div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> ७. बाबुको नाम, थर :-{{text7}}              </div><div class="col-md-4 col-sm-6"> बाबुको वतन :-{{text8}}</div><div class="col-md-4 col-sm-12"> नागरिकताको किसिम :-{{select5}}</div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> ८. आमाको नाम, थर :-{{text9}}</div><div class="col-md-4 col-sm-6"> आमाको वतन :-{{text10}}</div><div class="col-md-4 col-sm-12"> नागरिकताको किसिम :-{{select6}}</div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> ९. पतिको नाम, थर :-{{text11}}                  </div><div class="col-md-4 col-sm-6"> पतिको वतन :-{{text12}}</div><div class="col-md-4 col-sm-12"> नागरिकताको किसिम :-{{select7}}  </div></div><div class="row m-2 w-100"> <div class="col-12"> <p class="text-left"> माथि उल्लेखित विवरण मैले{{text14}}कार्यालयबाट लीएको नं.{{num1}}को ना.प्र.प. को व्यहोरा संग दुरुस्त छ।फरक छैन।लेखिएको व्यहोरा झुट्टा ठहरेमा कानुन बमोजिम सहुँला बुझाउँला । </p></div></div><div class="row my-2 w-100"> <div class="col-md-6"> <table style="border-color: transparent; margin: 8px;" border="1" cellpadding="5"> <tbody> <tr> <th style="text-align: center;" colspan="2">औंठा छाप</th> </tr></tbody> <tbody> <tr> <th style="border: solid 1px #000;">दायाँ</th> <th style="border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000;">बायाँ</th> </tr><tr> <td style="border: solid 1px #000; width: 88px; height: 88px;" height="88px">&nbsp;</td><td style="border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000; width: 88px; height: 88px;" height="88px">&nbsp;</td></tr></tbody> </table> </div><div class="col-md-6"> <p><strong>भवदिय</strong>, <br/>निवेदकको दस्तखत :-...................... <br/>नाम/थर :-{{name1}}<br/>मिति :-{{date1}}</p></div></div><div> <div style="text-decoration: underline;" class="text-center"> <strong>गाउँपालिका को प्रतिलिपि ना.प्र.प. का लागि सिफारिस </strong> </div></div><div class="row m-2 w-100"> <div class="col-md-12 written">{{text16}}{{select10}}वडा नं.{{number5}}मा मिति{{date2}}मा जन्म भई हाल{{text17}}{{text17}}वडा नं.{{num2}}मा स्थायी रुपमा बसोबास गरी आएका यसमा लेखिएका&nbsp;{{select11}}{{text19}}को{{select12}}वर्ष{{number7}}को{{select13}}{{text20}}लाई म चिन्दछु।निजको माग बमोजिम उपयुक्त विवरण भएको नं.{{number8}}मिति{{date6}}को नगरिकता प्रमाण-पत्रको सक्कल प्रति नया ढाँचाको आवश्यक भएको व्यहोरा साँचो हुँदा प्रतिलिपि दिएमा फरक नपर्ने व्यहोरा सिफारिस गर्दछु। उक्त विवरण झुठ्ठा ठहरे कानुन बमोजिम सँहुला बुझाउँला। </div><div class="row w-100 m-3"> <div class="col-md-4"> <div style='border: 1px solid black; font-size: 12px; width: 95px; height: 114px; display: flex; justify-content: center; align-items:center; text-align: center;'> दुवै कान देखिने हाल खिचिएको २.५ X ३ से.मी. फोटो </div></div><div class="col-md-4"> <p>कार्यालयको नाम र छाप :-</p><p>माईजोगमाई गाउँपालिका</p></div><div class="col-md-4"> <p>सिफारिस गर्नेको :-</p><p>दस्तखत :- ......................</p><p>नाम/थर :-{{}}</p><p>पद :-{{}}</p></div></div></div></div>`,
    data: {},
    values: [
      {
        key: "FormGroup",
        id: "1",
        title: "Nagarik",
        backgroundColor: "",
        border: "",
        // options: [
        //   { key: "1", value: "1" },
        //   { key: "2", value: "2" },
        // ],
        row: [
          [
            {
              key: "Number",
              language: "nepali",
              id: "num1",
              label: "ना प्र प नं.",
            },
            { key: "Date", id: "date1", language: "nepali", label: "मिति" },
          ],
          [
            {
              key: "Select",
              language: "nepali",
              label: "REASON  CITIZEN ",
              id: "select1",
              options: {
                1: "झुत्रो भएको",
                2: "हराएको",
                3: "नया ढाँचाको आवश्यक भएको",
              },
            },
            {
              key: "Select",
              language: "nepali",
              label: "किसिम ",
              id: "select2",
              options: {
                1: "वंशज",
                2: "जन्मको आधार",
                3: "वैवाहिक अंगीकृत",
                4: "जन्म सिद्ध",
              },
            },
          ],
        ],
      },
      {
        key: "FormGroup",
        id: "2",
        title: "व्यक्तिगत विवरण",
        backgroundColor: "",
        border: "",
        // options: [
        //   { key: "1", value: "1" },
        //   { key: "2", value: "2" },
        // ],
        row: [
          [
            { key: "Name", language: "nepali", id: "name1" },
            { key: "Name", language: "english", id: "name2" },
          ],
          [
            {
              key: "Date",
              id: "date2",
              language: "nepali",
              label: "जन्म मिति (बि.सं)",
            },
            {
              key: "Date",
              id: "date4",
              language: "english",
              label: "Date of birth (A.D)",
            },
          ],
          [
            {
              key: "Select",
              language: "nepali",
              label: "लिङ्ग",
              id: "select3",
              options: {
                "": "---लिङ्ग छान्नुहोस्---",
                1: "male",
                2: "female",
                3: "other",
              },
            },
            {
              key: "Select",
              language: "english",
              label: "Gender",
              id: "select4",
              options: {
                "": "---Select gender---",
                1: "male",
                2: "female",
                3: "other",
              },
            },
          ],
        ],
      },
      {
        key: "FormGroup",
        id: "3",
        title: "जन्मेको ठेगाना",
        backgroundColor: "",
        border: "",
        // options: [
        //   { key: "1", value: "1" },
        //   { key: "2", value: "2" },
        // ],
        row: [
          [
            {
              key: "Text",
              language: "nepali",
              id: "text1",
              label: "जन्म स्थान",
            },
            {
              key: "Text",
              language: "english",
              id: "text2",
              label: "Place of Birth (in block)",
            },
          ],
          [
            {
              key: "FormGroup",
              id: "2",
              title: "स्थायी बासस्थान",
              noBorder: true,
              row: [
                [
                  {
                    key: "Text",
                    language: "nepali",
                    id: "text3",
                    label: "जिल्ला",
                  },
                  {
                    key: "Text",
                    language: "nepali",
                    id: "text4",
                    label: "",
                  },
                  {
                    key: "Number",
                    language: "nepali",
                    id: "num2",
                    label: "वडा नं.",
                  },
                ],
              ],
            },
          ],
          [
            {
              key: "FormGroup",
              id: "4",
              title: "Permanent Address",
              noBorder: true,
              row: [
                [
                  {
                    key: "Text",
                    language: "english",
                    id: "text5",
                    label: "District",
                    properties: {
                      isRequired: true,
                      length: 10,
                      language: "nepali",
                      validation: {
                        length: 10,
                      },
                    },
                  },
                  {
                    key: "Text",
                    language: "english",
                    id: "text6",
                    label: "",
                  },
                  {
                    key: "Number",
                    language: "english",
                    id: "num3",
                    label: "Ward no",
                  },
                ],
              ],
            },
          ],
        ],
      },
      {
        key: "FormGroup",
        id: "3",
        title: "पारिवारिक विवरण",
        row: [
          [
            {
              key: "Text",
              language: "nepali",
              id: "text7",
              label: "बाबुको नाम, थर",
            },
            {
              key: "Text",
              language: "nepali",
              id: "text8",
              label: "बाबुको वतन",
            },
            {
              key: "Select",
              language: "nepali",
              label: "नागरिकताको किसिम ",
              id: "tsel13",
              options: {
                1: "वंशज",
                2: "जन्मको आधार",
                3: "वैवाहिक अंगीकृत",
                4: "जन्म सिद्ध",
              },
            },
          ],
          [
            {
              key: "Text",
              language: "nepali",
              id: "text9",
              label: "आमाको नाम, थर",
            },
            {
              key: "Text",
              language: "nepali",
              id: "text10",
              label: "आमाको वतन",
            },
            {
              key: "Select",
              language: "nepali",
              label: "नागरिकताको किसिम ",
              id: "select6",
              options: {
                1: "वंशज",
                2: "जन्मको आधार",
                3: "वैवाहिक अंगीकृत",
                4: "जन्म सिद्ध",
              },
            },
          ],
          [
            {
              key: "Text",
              language: "nepali",
              id: "text11",
              label: "पतिको नाम, थर",
            },
            {
              key: "Text",
              language: "nepali",
              id: "text12",
              label: "पतिको वतन",
            },
            {
              key: "Select",
              language: "nepali",
              label: "नागरिकताको किसिम ",
              id: "select7",
              options: {
                1: "वंशज",
                2: "जन्मको आधार",
                3: "वैवाहिक अंगीकृत",
                4: "जन्म सिद्ध",
              },
            },
          ],
        ],
      },
    ],
  },

  {
    id: "dfa",
    files: [
      "नागरिकता प्रमाणपत्रको प्रतिलिपि",
      "जन्म दर्ता प्रमाणपत्रको प्रतिलिपि",
      //not required
    ],
    name: "Aaaa", //required
    config: {
      isNewFormat: true,
    },
    preview: `<div class="col-md-12 respect"> <p>श्रीमान&nbsp;प्रमुख जिल्ला अधिकारीज्यू<br/>{{select1}}प्रशासन कार्यालय<br/>{{text1}}।</p><h3 style="text-align: center;"><strong>विषय:&nbsp;<u>नेपाली नागरिकताको प्रमाण-पत्र प्रतिलिपि पाऊँ।</u></strong></h3></div><div class="col-md-12 respect"> <p>महोदय,</p></div><div class="col-md-12 respect"><p>मैले माईजोगमाई गाउँपालिका कार्यालयबाट देहायको विवरण भएको नेपाली नागरिकता प्रमाण-पत्र लिएकोमा सो प्रमाण-पत्रको सक्कल{{select2}}हुँदा सोको प्रतिलिपि पाउनको लागि सो नागरिकता प्रमाण-पत्रको प्रति संलग्न राखि रु. १३ (तेह्र) को टिकट टाँसी सिफारिस सहित यो निवेदन पेश गरेको छु।</p></div><h4 align="center">मैले नागरिकताको प्रमाण-पत्र लिदाको यस प्रकार छ ।</h4><div style="margin: 10px;border: 1px solid black; width: 100%; padding: 8px" border="1"> <div class="row w-100"> <div class="col-md-4 col-sm-6"> १. ना प्र प नं. :-{{number1}}</div><div class="col-md-4 col-sm-6"> मिति :-{{date1}}</div><div class="col-md-4 col-sm-12"> किसिम :-{{select3}}</div></div><div class="row w-100"> <div class='col-12'> २. नाम थर :-{{text2}}</div></div><div class="row w-100"> <div class='col-12'> FULL NAME (IN BLOCK) :-{{text3}}</div></div><div class="row w-100"> <div class="col-md-6"> ३. लिङ्ग :-{{select5}}  </div><div class="col-md-6"> Sex :-{{select6}}</div></div><div class="row w-100"> <div class='col-12'> ४. जन्म स्थान :-{{text4}}</div></div><div class="row w-100"> <div class='col-12'> Place of Birth (in block) :-{{text5}}</div></div><div class="row w-100"> <div class="col-12"> ५. स्थायी बासस्थान: </div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> जिल्ला :-{{text6}}</div><div class="col-md-4 col-sm-6">{{}}</div><div class="col-md-4 col-sm-12"> वडा नं. :-{{number2}}</div></div><div class="row w-100"> <div class="col-12"> Permanent Address:- </div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> District :-{{text22}}</div><div class="col-md-4 col-sm-6">{{}}</div><div class="col-md-4 col-sm-12"> Ward no :-{{number3}}</div></div><div class="row w-100"> <div class="col-md-6"> ६. जन्म मिति (बि.सं) :-{{date2}}</div><div class="col-md-6"> Date of birth (A.D) :-{{date3}}</div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> ७. बाबुको नाम, थर :-{{text8}}              </div><div class="col-md-4 col-sm-6"> बाबुको वतन :-{{text9}}</div><div class="col-md-4 col-sm-12"> नागरिकताको किसिम :-{{select7}}</div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> ८. आमाको नाम, थर :-{{text10}}</div><div class="col-md-4 col-sm-6"> आमाको वतन :-{{text11}}</div><div class="col-md-4 col-sm-12"> नागरिकताको किसिम :-{{select8}}</div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> ९. पतिको नाम, थर :-{{text12}}                  </div><div class="col-md-4 col-sm-6"> पतिको वतन :-{{text13}}</div><div class="col-md-4 col-sm-12"> नागरिकताको किसिम :-{{select9}}  </div></div><div class="row m-2 w-100"> <div class="col-12"> <p class="text-left"> माथि उल्लेखित विवरण मैले{{text14}}कार्यालयबाट लीएको नं.{{number4}}को ना.प्र.प. को व्यहोरा संग दुरुस्त छ।फरक छैन।लेखिएको व्यहोरा झुट्टा ठहरेमा कानुन बमोजिम सहुँला बुझाउँला । </p></div></div><div class="row my-2 w-100"> <div class="col-md-6"> <table style="border-color: transparent; margin: 8px;" border="1" cellpadding="5"> <tbody> <tr> <th style="text-align: center;" colspan="2">औंठा छाप</th> </tr></tbody> <tbody> <tr> <th style="border: solid 1px #000;">दायाँ</th> <th style="border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000;">बायाँ</th> </tr><tr> <td style="border: solid 1px #000; width: 88px; height: 88px;" height="88px">&nbsp;</td><td style="border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000; width: 88px; height: 88px;" height="88px">&nbsp;</td></tr></tbody> </table> </div><div class="col-md-6"> <p><strong>भवदिय</strong>, <br/>निवेदकको दस्तखत :-...................... <br/>नाम/थर :-{{text15}}<br/>मिति :-{{date4}}</p></div></div><div> <div style="text-decoration: underline;" class="text-center"> <strong>गाउँपालिका को प्रतिलिपि ना.प्र.प. का लागि सिफारिस </strong> </div></div><div class="row m-2 w-100"> <div class="col-md-12 written">{{text16}}{{select10}}वडा नं.{{number5}}मा मिति{{date5}}मा जन्म भई हाल{{text17}}{{text17}}वडा नं.{{number6}}मा स्थायी रुपमा बसोबास गरी आएका यसमा लेखिएका&nbsp;{{select11}}{{text19}}को{{select12}}वर्ष{{number7}}को{{select13}}{{text20}}लाई म चिन्दछु।निजको माग बमोजिम उपयुक्त विवरण भएको नं.{{number8}}मिति{{date6}}को नगरिकता प्रमाण-पत्रको सक्कल प्रति नया ढाँचाको आवश्यक भएको व्यहोरा साँचो हुँदा प्रतिलिपि दिएमा फरक नपर्ने व्यहोरा सिफारिस गर्दछु। उक्त विवरण झुठ्ठा ठहरे कानुन बमोजिम सँहुला बुझाउँला। </div><div class="row w-100 m-3"> <div class="col-md-4"> <div style='border: 1px solid black; font-size: 12px; width: 95px; height: 114px; display: flex; justify-content: center; align-items:center; text-align: center;'> दुवै कान देखिने हाल खिचिएको २.५ X ३ से.मी. फोटो </div></div><div class="col-md-4"> <p>कार्यालयको नाम र छाप :-</p><p>माईजोगमाई गाउँपालिका</p></div><div class="col-md-4"> <p>सिफारिस गर्नेको :-</p><p>दस्तखत :- ......................</p><p>नाम/थर :-{{}}</p><p>पद :-{{}}</p></div></div></div></div>`,
    data: {},
    values: [
      {
        key: "Paragraph",
        isStatic: false,
        data: '<p>श्रीमान प्रमुख जिल्ला अधिकारीज्यू<br/><span id="select1"></span> प्रशासन कार्यालय<br/><span id="text1"></span> ।<br/>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong style="text-align: center;"> विषय: नेपाली नागरिकताको प्रमाण-पत्र प्रतिलिपि पाऊँ।</strong></p><p>महोदय,<br/>मैले माईजोगमाई गाउँपालिका कार्यालयबाट देहायको विवरण भएको नेपाली नागरिकता प्रमाण-पत्र लिएकोमा सो प्रमाणपत्रको सक्कल <span id="select2"></span> हुँदा सोको प्रतिलिपि पाउनको लागि सो नागरिकता प्रमाण-पत्रको प्रति संलग्न राखि रु. १३ (तेह्र) कोटिकट टाँसी सिफारिस सहित यो निवेदन पेश गरेको छु।</p><p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;मैले नागरिकताको प्रमाण-पत्र लिदाको यस प्रकार छ ।</p><table style="border-collapse: collapse; width: 100%; padding: 15px;" border="1"><tbody><tr><td style="width: 100%;"><p>१. ना प्र प नं. :- <span id="number1"></span>&nbsp; &nbsp; &nbsp; &nbsp; मिति :- <span id="date1"></span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; किसिम :- <span id="select3"></span><br/>२. नाम थर :- <span id="text2"></span> <br/>FULL NAME (IN BLOCK) :- <span id="text3"></span><br/>३. लिङ्ग :-<span id="select5"></span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Sex :- <span id="select6"></span><br/>४. जन्म स्थान :- <span id="text4"></span><br/>Place of Birth (in block) :- <span id="text5"></span><br/>५. स्थायी बासस्थान:<br/>जिल्ला :- <span id="text6"></span> माईजोगमाई गाउँपालिका&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;वडा नं. :- <span id="number2"></span><br/>Permanent Address:-<br/>District :-&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Ward no :- <span id="number3"></span><br/>६. जन्म मिति (बि.सं) :- <span id="date2"></span> Date of birth (A.D) :- <span id="date3"></span><br/>७. बाबुको नाम, थर :- <span id="text8"></span> बाबुको वतन :- <span id="text9"></span> नागरिकताको किसिम :- <span id="select7"></span><br/>८. आमाको नाम, थर :- <span id="text10"></span> आमाको वतन :- <span id="text11"></span> नागरिकताको किसिम :- <span id="select8"></span><br/>९. पतिको नाम, थर :- <span id="text12"></span> पतिको वतन :- <span id="text13"></span> नागरिकताको किसिम :- <span id="select9"></span></p><p>माथि उल्लेखित विवरण <span id="text14"></span> दपवजप कार्यालयबाट लीएको नं. <span id="number4"></span> को ना.प्र.प. को व्यहोरा संग दुरुस्त छ।फरक छैन।लेखिएको व्यहोरा झुट्टा ठहरेमा कानुन बमोजिम सहुँला बुझाउँला ।</p><div style="display: flex; justify-content: space-between;"><table style="border-color: transparent; margin: 8px;" border="1" cellpadding="5"><tbody><tr><th style="text-align: center;" colspan="2">औंठा छाप</th></tr></tbody><tbody><tr><th style="border: solid 1px #000;">दायाँ</th><th style="border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000;">बायाँ</th></tr><tr><td style="border: solid 1px #000; width: 88px; height: 80px;" height="80px">&nbsp;</td><td style="border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000; width: 88px; height: 80px;" height="80px">&nbsp;</td></tr></tbody></table><p><strong>भवदिय</strong>, <br/>निवेदकको दस्तखत :-...................... <br/>नाम/थर :- <span id="text15"></span> <br/>मिति :- <span id="date4"></span></p></div><p style="text-align: center;"><span style="text-decoration: underline;"><strong>गाउँपालिका को प्रतिलिपि ना.प्र.प. का लागि सिफारिस </strong></span></p><p><span id="text16"></span><span id="select10"></span> वडा नं. <span id="number5"></span> मा मिति <span id="date5"></span>मा जन्म भई हाल <span id="text17"></span> <span id="text18"></span> वडा नं. <span id="number6"></span>मा स्थायी रुपमा बसो बास गरी आएका यसमा लेखिएका <span id="select11"></span> <span id="text19"></span> को <span id="select12"></span> वर्ष <span id="number7"></span> को <span id="select13"></span> <span id="text20"></span> लाई म चिन्दछु।निजको माग बमोजिम उपयुक्त विवरण भएको नं. <span id="number8"></span> मिति <span id="date6"></span> को नगरिकता प्रमाण-पत्रको सक्कल प्रति <span id="text21"></span> व्यहोरा साँचो हुँदा प्रतिलिपि दिएमा फरक नपर्ने व्यहोरा सिफारिस गर्दछु। उक्त विवरण झुठ्ठा ठहरे कानुन बमो जिम सँहुला बुझाउँला।</p></td></tr></tbody></table><p>&nbsp;</p>',
        dataType: "html",

        fields: {
          text1: {
            type: "text",
            placeholder: "Name",
          },
          text2: {
            type: "text",
            placeholder: "Name",
          },
          text3: {
            type: "text",
            placeholder: "Name",
          },
          text4: {
            type: "text",
            placeholder: "Name",
          },
          text5: {
            type: "text",
            placeholder: "Name",
          },
          text6: {
            type: "text",
            placeholder: "Name",
          },
          text7: {
            type: "text",
            placeholder: "Name",
          },
          text8: {
            type: "text",
            placeholder: "Name",
          },
          text9: {
            type: "text",
            placeholder: "Name",
          },
          text10: {
            type: "text",
            placeholder: "Name",
          },
          text11: {
            type: "text",
            placeholder: "Name",
          },
          text12: {
            type: "text",
            placeholder: "Name",
          },
          text13: {
            type: "text",
            placeholder: "Name",
          },
          text14: {
            type: "text",
            placeholder: "Name",
          },
          text15: {
            type: "text",
            placeholder: "Name",
          },
          text16: {
            type: "text",
            placeholder: "Name",
          },
          text17: {
            type: "text",
            placeholder: "Name",
          },
          text18: {
            type: "text",
            placeholder: "Name",
          },
          text19: {
            type: "text",
            placeholder: "Name",
          },
          text20: {
            type: "text",
            placeholder: "Name",
          },
          text21: {
            type: "text",
            placeholder: "Name",
          },
          number1: {
            type: "number",
            placeholder: 23,
          },
          number2: {
            type: "number",
            placeholder: 23,
          },
          number3: {
            type: "number",
            placeholder: 23,
          },
          number4: {
            type: "number",
            placeholder: 23,
          },
          number5: {
            type: "number",
            placeholder: 23,
          },
          number6: {
            type: "number",
            placeholder: 23,
          },
          number7: {
            type: "number",
            placeholder: 23,
          },
          number8: {
            type: "number",
            placeholder: 23,
          },
          select1: {
            type: "select",
            options: [
              { key: "जिल्ला", value: "जिल्ला" },
              { key: "ईलाका", value: "ईलाका" },
            ],
          },

          select2: {
            type: "select",
            options: [
              { key: "झुत्रो भएको", value: "झुत्रो भएको" },
              { key: "हराएको", value: "हराएको" },
              {
                key: "नया ढाँचाको आवश्यक भएको",
                value: "नया ढाँचाको आवश्यक भएको",
              },
            ],
          },

          select3: {
            type: "select",
            options: [
              { key: "वंशज", value: "वंशज" },
              { key: "जन्मको आधार", value: "जन्मको आधार" },
              { key: "वैवाहिक अंगीकृत", value: "वैवाहिक अंगीकृत" },
              { key: "जन्म सिद्ध", value: "जन्म सिद्ध" },
            ],
          },
          select5: {
            type: "select",
            options: [
              { key: "पुरुष", value: "पुरुष" },
              { key: "महिला", value: "महिला" },
              { key: "अन्य", value: "अन्य" },
            ],
          },
          select6: {
            type: "select",
            options: [
              { key: "male", value: "male" },
              { key: "female", value: "female" },
              { key: "other", value: "other" },
            ],
          },
          select7: {
            type: "select",
            options: [
              { key: "वंशज", value: "वंशज" },
              { key: "जन्मको आधार", value: "जन्मको आधार" },
              { key: "वैवाहिक अंगीकृत", value: "वैवाहिक अंगीकृत" },
              { key: "जन्म सिद्ध", value: "जन्म सिद्ध" },
            ],
          },
          select8: {
            type: "select",
            options: [
              { key: "वंशज", value: "वंशज" },
              { key: "जन्मको आधार", value: "जन्मको आधार" },
              { key: "वैवाहिक अंगीकृत", value: "वैवाहिक अंगीकृत" },
              { key: "जन्म सिद्ध", value: "जन्म सिद्ध" },
            ],
          },
          select9: {
            type: "select",
            options: [
              { key: "वंशज", value: "वंशज" },
              { key: "जन्मको आधार", value: "जन्मको आधार" },
              { key: "वैवाहिक अंगीकृत", value: "वैवाहिक अंगीकृत" },
              { key: "जन्म सिद्ध", value: "जन्म सिद्ध" },
            ],
          },
          select10: {
            type: "select",
            options: [
              { key: "गा.वि.स.", value: "गा.वि.स." },
              { key: "नगरपालिका", value: "नगरपालिका" },
              { key: "उप महानगरपालिका", value: "उप महानगरपालिका" },
              { key: "महानगरपालिका", value: "महानगरपालिका" },
            ],
          },
          select11: {
            type: "select",
            options: [
              { key: "श्रीमान", value: "श्रीमान" },
              { key: "श्रीमती", value: "श्रीमती" },
            ],
          },
          select12: {
            type: "select",
            options: [
              { key: "छोरा", value: "छोरा" },
              { key: "छोरी", value: "छोरी" },
              { key: "श्रीमती", value: "श्रीमती" },
            ],
          },

          select13: {
            type: "select",
            options: [
              { key: "श्री", value: "श्री" },
              { key: "सुश्री", value: "सुश्री" },
              { key: "श्रीमती", value: "श्रीमती" },
            ],
          },

          date1: {
            type: "date",
            placeholder: "----/--/--",
          },
          date2: {
            type: "date",
            placeholder: "----/--/--",
          },
          date3: {
            type: "date",
            placeholder: "----/--/--",
          },
          date4: {
            type: "date",
            placeholder: "----/--/--",
          },
          date5: {
            type: "date",
            placeholder: "----/--/--",
          },
          date6: {
            type: "date",
            placeholder: "----/--/--",
          },
        },
      },
    ],
  },

  {
    id: "dfa1",
    files: [
      "नागरिकता प्रमाणपत्रको प्रतिलिपि",
      "जन्म दर्ता प्रमाणपत्रको प्रतिलिपि",
      //not required
    ],
    isNewFormat: false,
    name: "Aaaa", //required
    preview: 1, // or null
    values: [
      {
        key: "Paragraph",
        isStatic: false,
        data: '<p>श्रीमान प्रमुख जिल्ला अधिकारीज्यू<br/><span id="select1"></span> प्रशासन कार्यालय<br/><span id="text1"></span> ।<br/>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong style="text-align: center;"> विषय: नेपाली नागरिकताको प्रमाण-पत्र प्रतिलिपि पाऊँ।</strong></p><p>महोदय,<br/>मैले माईजोगमाई गाउँपालिका कार्यालयबाट देहायको विवरण भएको नेपाली नागरिकता प्रमाण-पत्र लिएकोमा सो प्रमाणपत्रको सक्कल <span id="select2"></span> हुँदा सोको प्रतिलिपि पाउनको लागि सो नागरिकता प्रमाण-पत्रको प्रति संलग्न राखि रु. १३ (तेह्र) कोटिकट टाँसी सिफारिस सहित यो निवेदन पेश गरेको छु।</p><p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;मैले नागरिकताको प्रमाण-पत्र लिदाको यस प्रकार छ ।</p><table style="border-collapse: collapse; width: 100%; padding: 15px;" border="1"><tbody><tr><td style="width: 100%;"><p>१. ना प्र प नं. :- <span id="number1"></span>&nbsp; &nbsp; &nbsp; &nbsp; मिति :- <span id="date1"></span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; किसिम :- <span id="select3"></span><br/>२. नाम थर :- <span id="text2"></span> <br/>FULL NAME (IN BLOCK) :- <span id="text3"></span><br/>३. लिङ्ग :-<span id="select5"></span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Sex :- <span id="select6"></span><br/>४. जन्म स्थान :- <span id="text4"></span><br/>Place of Birth (in block) :- <span id="text5"></span><br/>५. स्थायी बासस्थान:<br/>जिल्ला :- <span id="text6"></span> माईजोगमाई गाउँपालिका&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;वडा नं. :- <span id="number2"></span><br/>Permanent Address:-<br/>District :-&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Ward no :- <span id="number3"></span><br/>६. जन्म मिति (बि.सं) :- <span id="date2"></span> Date of birth (A.D) :- <span id="date3"></span><br/>७. बाबुको नाम, थर :- <span id="text8"></span> बाबुको वतन :- <span id="text9"></span> नागरिकताको किसिम :- <span id="select7"></span><br/>८. आमाको नाम, थर :- <span id="text10"></span> आमाको वतन :- <span id="text11"></span> नागरिकताको किसिम :- <span id="select8"></span><br/>९. पतिको नाम, थर :- <span id="text12"></span> पतिको वतन :- <span id="text13"></span> नागरिकताको किसिम :- <span id="select9"></span></p><p>माथि उल्लेखित विवरण <span id="text14"></span> दपवजप कार्यालयबाट लीएको नं. <span id="number4"></span> को ना.प्र.प. को व्यहोरा संग दुरुस्त छ।फरक छैन।लेखिएको व्यहोरा झुट्टा ठहरेमा कानुन बमोजिम सहुँला बुझाउँला ।</p><div style="display: flex; justify-content: space-between;"><table style="border-color: transparent; margin: 8px;" border="1" cellpadding="5"><tbody><tr><th style="text-align: center;" colspan="2">औंठा छाप</th></tr></tbody><tbody><tr><th style="border: solid 1px #000;">दायाँ</th><th style="border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000;">बायाँ</th></tr><tr><td style="border: solid 1px #000; width: 88px; height: 80px;" height="80px">&nbsp;</td><td style="border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000; width: 88px; height: 80px;" height="80px">&nbsp;</td></tr></tbody></table><p><strong>भवदिय</strong>, <br/>निवेदकको दस्तखत :-...................... <br/>नाम/थर :- <span id="text15"></span> <br/>मिति :- <span id="date4"></span></p></div><p style="text-align: center;"><span style="text-decoration: underline;"><strong>गाउँपालिका को प्रतिलिपि ना.प्र.प. का लागि सिफारिस </strong></span></p><p><span id="text16"></span><span id="select10"></span> वडा नं. <span id="number5"></span> मा मिति <span id="date5"></span>मा जन्म भई हाल <span id="text17"></span> <span id="text18"></span> वडा नं. <span id="number6"></span>मा स्थायी रुपमा बसो बास गरी आएका यसमा लेखिएका <span id="select11"></span> <span id="text19"></span> को <span id="select12"></span> वर्ष <span id="number7"></span> को <span id="select13"></span> <span id="text20"></span> लाई म चिन्दछु।निजको माग बमोजिम उपयुक्त विवरण भएको नं. <span id="number8"></span> मिति <span id="date6"></span> को नगरिकता प्रमाण-पत्रको सक्कल प्रति <span id="text21"></span> व्यहोरा साँचो हुँदा प्रतिलिपि दिएमा फरक नपर्ने व्यहोरा सिफारिस गर्दछु। उक्त विवरण झुठ्ठा ठहरे कानुन बमो जिम सँहुला बुझाउँला।</p></td></tr></tbody></table><p>&nbsp;</p>',
        dataType: "html",

        fields: {
          text1: {
            type: "text",
            placeholder: "Name",
          },
          text2: {
            type: "text",
            placeholder: "Name",
          },
          text3: {
            type: "text",
            placeholder: "Name",
          },
          text4: {
            type: "text",
            placeholder: "Name",
          },
          text5: {
            type: "text",
            placeholder: "Name",
          },
          text6: {
            type: "text",
            placeholder: "Name",
          },
          text7: {
            type: "text",
            placeholder: "Name",
          },
          text8: {
            type: "text",
            placeholder: "Name",
          },
          text9: {
            type: "text",
            placeholder: "Name",
          },
          text10: {
            type: "text",
            placeholder: "Name",
          },
          text11: {
            type: "text",
            placeholder: "Name",
          },
          text12: {
            type: "text",
            placeholder: "Name",
          },
          text13: {
            type: "text",
            placeholder: "Name",
          },
          text14: {
            type: "text",
            placeholder: "Name",
          },
          text15: {
            type: "text",
            placeholder: "Name",
          },
          text16: {
            type: "text",
            placeholder: "Name",
          },
          text17: {
            type: "text",
            placeholder: "Name",
          },
          text18: {
            type: "text",
            placeholder: "Name",
          },
          text19: {
            type: "text",
            placeholder: "Name",
          },
          text20: {
            type: "text",
            placeholder: "Name",
          },
          text21: {
            type: "text",
            placeholder: "Name",
          },
          number1: {
            type: "number",
            placeholder: 23,
          },
          number2: {
            type: "number",
            placeholder: 23,
          },
          number3: {
            type: "number",
            placeholder: 23,
          },
          number4: {
            type: "number",
            placeholder: 23,
          },
          number5: {
            type: "number",
            placeholder: 23,
          },
          number6: {
            type: "number",
            placeholder: 23,
          },
          number7: {
            type: "number",
            placeholder: 23,
          },
          number8: {
            type: "number",
            placeholder: 23,
          },
          select1: {
            type: "select",
            options: [
              { key: "जिल्ला", value: "जिल्ला" },
              { key: "ईलाका", value: "ईलाका" },
            ],
          },

          select2: {
            type: "select",
            options: [
              { key: "झुत्रो भएको", value: "झुत्रो भएको" },
              { key: "हराएको", value: "हराएको" },
              {
                key: "नया ढाँचाको आवश्यक भएको",
                value: "नया ढाँचाको आवश्यक भएको",
              },
            ],
          },

          select3: {
            type: "select",
            options: [
              { key: "वंशज", value: "वंशज" },
              { key: "जन्मको आधार", value: "जन्मको आधार" },
              { key: "वैवाहिक अंगीकृत", value: "वैवाहिक अंगीकृत" },
              { key: "जन्म सिद्ध", value: "जन्म सिद्ध" },
            ],
          },
          select5: {
            type: "select",
            options: [
              { key: "पुरुष", value: "पुरुष" },
              { key: "महिला", value: "महिला" },
              { key: "अन्य", value: "अन्य" },
            ],
          },
          select6: {
            type: "select",
            options: [
              { key: "male", value: "male" },
              { key: "female", value: "female" },
              { key: "other", value: "other" },
            ],
          },
          select7: {
            type: "select",
            options: [
              { key: "वंशज", value: "वंशज" },
              { key: "जन्मको आधार", value: "जन्मको आधार" },
              { key: "वैवाहिक अंगीकृत", value: "वैवाहिक अंगीकृत" },
              { key: "जन्म सिद्ध", value: "जन्म सिद्ध" },
            ],
          },
          select8: {
            type: "select",
            options: [
              { key: "वंशज", value: "वंशज" },
              { key: "जन्मको आधार", value: "जन्मको आधार" },
              { key: "वैवाहिक अंगीकृत", value: "वैवाहिक अंगीकृत" },
              { key: "जन्म सिद्ध", value: "जन्म सिद्ध" },
            ],
          },
          select9: {
            type: "select",
            options: [
              { key: "वंशज", value: "वंशज" },
              { key: "जन्मको आधार", value: "जन्मको आधार" },
              { key: "वैवाहिक अंगीकृत", value: "वैवाहिक अंगीकृत" },
              { key: "जन्म सिद्ध", value: "जन्म सिद्ध" },
            ],
          },
          select10: {
            type: "select",
            options: [
              { key: "गा.वि.स.", value: "गा.वि.स." },
              { key: "नगरपालिका", value: "नगरपालिका" },
              { key: "उप महानगरपालिका", value: "उप महानगरपालिका" },
              { key: "महानगरपालिका", value: "महानगरपालिका" },
            ],
          },
          select11: {
            type: "select",
            options: [
              { key: "श्रीमान", value: "श्रीमान" },
              { key: "श्रीमती", value: "श्रीमती" },
            ],
          },
          select12: {
            type: "select",
            options: [
              { key: "छोरा", value: "छोरा" },
              { key: "छोरी", value: "छोरी" },
              { key: "श्रीमती", value: "श्रीमती" },
            ],
          },

          select13: {
            type: "select",
            options: [
              { key: "श्री", value: "श्री" },
              { key: "सुश्री", value: "सुश्री" },
              { key: "श्रीमती", value: "श्रीमती" },
            ],
          },

          date1: {
            type: "date",
            placeholder: "----/--/--",
          },
          date2: {
            type: "date",
            placeholder: "----/--/--",
          },
          date3: {
            type: "date",
            placeholder: "----/--/--",
          },
          date4: {
            type: "date",
            placeholder: "----/--/--",
          },
          date5: {
            type: "date",
            placeholder: "----/--/--",
          },
          date6: {
            type: "date",
            placeholder: "----/--/--",
          },
        },
      },
      {
        key: "formGroup",
        title: "thistak",
        backgroundColor: "",
        border: "",
        options: [
          { key: "1", value: "1" },
          { key: "2", value: "2" },
        ],
        row: [
          [
            {
              key: "input",
            },
          ],
          [{ key: "" }],
        ],
      },
    ],
  },
  {
    id: "dfa3",
    files: [
      "नागरिकता प्रमाणपत्रको प्रतिलिपि",
      "जन्म दर्ता प्रमाणपत्रको प्रतिलिपि",
      //not required
    ],
    isNewFormat: true,
    name: "New", //required
    preview: 1, // or null
    values: [
      {
        key: "Name",
        isStatic: false,
      },
    ],
  },
];

export const preview = [
  {
    data: `<div class="col-md-12 respect"> <p>श्रीमान&nbsp;प्रमुख जिल्ला अधिकारीज्यू<br/>{{select1}}प्रशासन कार्यालय<br/>{{text1}}।</p><h3 style="text-align: center;"><strong>विषय:&nbsp;<u>नेपाली नागरिकताको प्रमाण-पत्र प्रतिलिपि पाऊँ।</u></strong></h3></div><div class="col-md-12 respect"> <p>महोदय,</p></div><div class="col-md-12 respect"><p>मैले माईजोगमाई गाउँपालिका कार्यालयबाट देहायको विवरण भएको नेपाली नागरिकता प्रमाण-पत्र लिएकोमा सो प्रमाण-पत्रको सक्कल{{select2}}हुँदा सोको प्रतिलिपि पाउनको लागि सो नागरिकता प्रमाण-पत्रको प्रति संलग्न राखि रु. १३ (तेह्र) को टिकट टाँसी सिफारिस सहित यो निवेदन पेश गरेको छु।</p></div><h4 align="center">मैले नागरिकताको प्रमाण-पत्र लिदाको यस प्रकार छ ।</h4><div style="margin: 10px;border: 1px solid black; width: 100%; padding: 8px" border="1"> <div class="row w-100"> <div class="col-md-4 col-sm-6"> १. ना प्र प नं. :-{{number1}}</div><div class="col-md-4 col-sm-6"> मिति :-{{date1}}</div><div class="col-md-4 col-sm-12"> किसिम :-{{select3}}</div></div><div class="row w-100"> <div class='col-12'> २. नाम थर :-{{text2}}</div></div><div class="row w-100"> <div class='col-12'> FULL NAME (IN BLOCK) :-{{text3}}</div></div><div class="row w-100"> <div class="col-md-6"> ३. लिङ्ग :-{{select5}}  </div><div class="col-md-6"> Sex :-{{select6}}</div></div><div class="row w-100"> <div class='col-12'> ४. जन्म स्थान :-{{text4}}</div></div><div class="row w-100"> <div class='col-12'> Place of Birth (in block) :-{{text5}}</div></div><div class="row w-100"> <div class="col-12"> ५. स्थायी बासस्थान: </div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> जिल्ला :-{{text6}}</div><div class="col-md-4 col-sm-6">{{}}</div><div class="col-md-4 col-sm-12"> वडा नं. :-{{number2}}</div></div><div class="row w-100"> <div class="col-12"> Permanent Address:- </div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> District :-{{text22}}</div><div class="col-md-4 col-sm-6">{{}}</div><div class="col-md-4 col-sm-12"> Ward no :-{{number3}}</div></div><div class="row w-100"> <div class="col-md-6"> ६. जन्म मिति (बि.सं) :-{{date2}}</div><div class="col-md-6"> Date of birth (A.D) :-{{date3}}</div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> ७. बाबुको नाम, थर :-{{text8}}              </div><div class="col-md-4 col-sm-6"> बाबुको वतन :-{{text9}}</div><div class="col-md-4 col-sm-12"> नागरिकताको किसिम :-{{select7}}</div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> ८. आमाको नाम, थर :-{{text10}}</div><div class="col-md-4 col-sm-6"> आमाको वतन :-{{text11}}</div><div class="col-md-4 col-sm-12"> नागरिकताको किसिम :-{{select8}}</div></div><div class="row w-100"> <div class="col-md-4 col-sm-6"> ९. पतिको नाम, थर :-{{text12}}                  </div><div class="col-md-4 col-sm-6"> पतिको वतन :-{{text13}}</div><div class="col-md-4 col-sm-12"> नागरिकताको किसिम :-{{select9}}  </div></div><div class="row m-2 w-100"> <div class="col-12"> <p class="text-left"> माथि उल्लेखित विवरण मैले{{text14}}कार्यालयबाट लीएको नं.{{number4}}को ना.प्र.प. को व्यहोरा संग दुरुस्त छ।फरक छैन।लेखिएको व्यहोरा झुट्टा ठहरेमा कानुन बमोजिम सहुँला बुझाउँला । </p></div></div><div class="row my-2 w-100"> <div class="col-md-6"> <table style="border-color: transparent; margin: 8px;" border="1" cellpadding="5"> <tbody> <tr> <th style="text-align: center;" colspan="2">औंठा छाप</th> </tr></tbody> <tbody> <tr> <th style="border: solid 1px #000;">दायाँ</th> <th style="border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000;">बायाँ</th> </tr><tr> <td style="border: solid 1px #000; width: 88px; height: 88px;" height="88px">&nbsp;</td><td style="border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000; width: 88px; height: 88px;" height="88px">&nbsp;</td></tr></tbody> </table> </div><div class="col-md-6"> <p><strong>भवदिय</strong>, <br/>निवेदकको दस्तखत :-...................... <br/>नाम/थर :-{{text15}}<br/>मिति :-{{date4}}</p></div></div><div> <div style="text-decoration: underline;" class="text-center"> <strong>गाउँपालिका को प्रतिलिपि ना.प्र.प. का लागि सिफारिस </strong> </div></div><div class="row m-2 w-100"> <div class="col-md-12 written">{{text16}}{{select10}}वडा नं.{{number5}}मा मिति{{date5}}मा जन्म भई हाल{{text17}}{{text17}}वडा नं.{{number6}}मा स्थायी रुपमा बसोबास गरी आएका यसमा लेखिएका&nbsp;{{select11}}{{text19}}को{{select12}}वर्ष{{number7}}को{{select13}}{{text20}}लाई म चिन्दछु।निजको माग बमोजिम उपयुक्त विवरण भएको नं.{{number8}}मिति{{date6}}को नगरिकता प्रमाण-पत्रको सक्कल प्रति नया ढाँचाको आवश्यक भएको व्यहोरा साँचो हुँदा प्रतिलिपि दिएमा फरक नपर्ने व्यहोरा सिफारिस गर्दछु। उक्त विवरण झुठ्ठा ठहरे कानुन बमोजिम सँहुला बुझाउँला। </div><div class="row w-100 m-3"> <div class="col-md-4"> <div style='border: 1px solid black; font-size: 12px; width: 95px; height: 114px; display: flex; justify-content: center; align-items:center; text-align: center;'> दुवै कान देखिने हाल खिचिएको २.५ X ३ से.मी. फोटो </div></div><div class="col-md-4"> <p>कार्यालयको नाम र छाप :-</p><p>माईजोगमाई गाउँपालिका</p></div><div class="col-md-4"> <p>सिफारिस गर्नेको :-</p><p>दस्तखत :- ......................</p><p>नाम/थर :-{{}}</p><p>पद :-{{}}</p></div></div></div></div>`,
    id: 1,
    map: { "watako dfadsf": "select1" },
  },
];

// Correct format template
// {
//   "category": 1,
//   "title": "Citizenship Certificate Recommendation",
//   "charge": "275",
//   "document": [
//       1
//   ],
//   "icon": "icon/nag.png",
//   "additional_info": "lorem ipsum dor",
//   "data": {},
//   "preview": "<div class='col-12 respect'> <p>श्रीमान&nbsp; {{post}} <br/> {{ward_name}}  प्रशासन कार्यालय<br/> {{ward_address}} ,  {{nagarpalika_address}} ।</p><h4 style='text-align: center;'><strong>विषय:&nbsp;<u>नेपाली नागरिकताको प्रमाण-पत्र प्रतिलिपि पाऊँ।</u></strong></h4></div><div class='col-12 respect'> <p>महोदय,</p></div><div class='col-12 respect'><p>मैले  {{text14}}  कार्यालयबाट देहायको विवरण भएको नेपाली नागरिकता प्रमाण-पत्र लिएकोमा सो प्रमाण-पत्रको सक्कल {{select2}} हुँदा सोको प्रतिलिपि पाउनको लागि सो नागरिकता प्रमाण-पत्रको प्रति संलग्न राखि रु. १३ (तेह्र) को टिकट टाँसी सिफारिस सहित यो निवेदन पेश गरेको छु।</p></div><h4 align='center'>मैले नागरिकताको प्रमाण-पत्र लिदाको यस प्रकार छ ।</h4><div style='margin: 10px;border: 1px solid black; width: 100%; padding: 8px' border='1'> <div class='row w-100'> <div class='col-4'> १. ना प्र प नं. :- {{num1}} </div><div class='col-4'> मिति :- {{date1}} </div><div class='col-4'> किसिम :- {{select2}} </div></div><div class='row w-100'> <div class='col-12'> २. नाम थर :- {{name1}} </div></div><div class='row w-100'> <div class='col-12'> FULL NAME (IN BLOCK) :- {{name2}} </div></div><div class='row w-100'> <div class='col-6'> ३. लिङ्ग :- {{select3}}   </div><div class='col-6'> Sex :- {{select4}} </div></div><div class='row w-100'> <div class='col-12'> ४. जन्म स्थान :- {{text1}} </div></div><div class='row w-100'> <div class='col-12'> Place of Birth (in block) :- {{text2}} </div></div><div class='row w-100'> <div class='col-12'> ५. स्थायी बासस्थान: </div></div><div class='row w-100'> <div class='col-4'> जिल्ला :- {{text3}} </div><div class='col-4'> {{text4}} </div><div class='col-4'> वडा नं. :- {{num2}} </div></div><div class='row w-100'> <div class='col-12'> Permanent Address:- </div></div><div class='row w-100'> <div class='col-4'> District :- {{text5}} </div><div class='col-4'> {{text6}} </div><div class='col-4 '> Ward no :- {{num3}} </div></div><div class='row w-100'> <div class='col-6'> ६. जन्म मिति (बि.सं) :- {{date2}} </div><div class='col-6'> Date of birth (A.D) :- {{date3}} </div></div><div class='row w-100'> <div class='col-4'> ७. बाबुको नाम, थर :- {{text7}}               </div><div class='col-4'> बाबुको वतन :- {{text8}} </div><div class='col-4'> नागरिकताको किसिम :- {{select5}} </div></div><div class='row w-100'> <div class='col-4'> ८. आमाको नाम, थर :- {{text9}} </div><div class='col-4'> आमाको वतन :- {{text10}} </div><div class='col-4'> नागरिकताको किसिम :- {{select6}} </div></div><div class='row w-100'> <div class='col-4'> ९. पतिको नाम, थर :- {{text11}}                   </div><div class='col-4'> पतिको वतन :- {{text12}} </div><div class='col-4'> नागरिकताको किसिम :- {{select7}}   </div></div><div class='row m-2 w-100'> <div class='col-12'> <p class='text-left'> माथि उल्लेखित विवरण मैले {{text14}} कार्यालयबाट लीएको नं. {{num1}} को ना.प्र.प. को व्यहोरा संग दुरुस्त छ।फरक छैन।लेखिएको व्यहोरा झुट्टा ठहरेमा कानुन बमोजिम सहुँला बुझाउँला । </p></div></div><div class='row my-2 w-100'> <div class='col-6'> <table style='border-color: transparent; margin: 8px;' border='1' cellpadding='5'> <tbody> <tr> <th style='text-align: center;' colspan='2'>औंठा छाप</th> </tr></tbody> <tbody> <tr> <th style='border: solid 1px #000;'>दायाँ</th> <th style='border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000;'>बायाँ</th> </tr><tr> <td style='border: solid 1px #000; width: 88px; height: 88px;' height='88px'>&nbsp;</td><td style='border-top: solid 1px #000; border-bottom: solid 1px #000; border-right: solid 1px #000; width: 88px; height: 88px;' height='88px'>&nbsp;</td></tr></tbody> </table> </div><div class='col-6'> <p><strong>भवदिय</strong>, <br/>निवेदकको दस्तखत :-...................... <br/>नाम/थर :- {{name1}} <br/>मिति :- {{date1}} </p></div></div><div> <div style='text-decoration: underline;' class='text-center'> <strong>गाउँपालिका को प्रतिलिपि ना.प्र.प. का लागि सिफारिस </strong> </div></div><div class='row m-2 w-100'> <div class='col-12 written'> {{nagarpalika_address}}  {{nagarpalika_name}}  {{ward_name}} मा मिति {{date2}} मा जन्म भई हाल {{text3}}  {{text4}} वडा नं. {{num2}} मा स्थायी रुपमा बसोबास गरी आएका यसमा लेखिएका&nbsp;श्रीमान  {{text7}} को  {{relation}}  वर्ष  {{age}} को  {{respect}}  {{name1}} लाई म चिन्दछु।निजको माग बमोजिम उपयुक्त विवरण भएको नं. {{number8}} मिति {{date6}} को नगरिकता प्रमाण-पत्रको सक्कल प्रति नया ढाँचाको आवश्यक भएको व्यहोरा साँचो हुँदा प्रतिलिपि दिएमा फरक नपर्ने व्यहोरा सिफारिस गर्दछु। उक्त विवरण झुठ्ठा ठहरे कानुन बमोजिम सँहुला बुझाउँला। </div><div class='row w-100 m-3'> <div class='col-4'> <div style='border: 1px solid black; font-size: 12px; width: 95px; height: 114px; display: flex; justify-content: center; align-items:center; text-align: center;'> दुवै कान देखिने हाल खिचिएको २.५ X ३ से.मी. फोटो </div></div><div class='col-4'> <p>कार्यालयको नाम र छाप :-</p><p>माईजोगमाई गाउँपालिका</p></div><div class='col-4'> <p>सिफारिस गर्नेको :-</p><br/><p>दस्तखत :- ......................</p><p>नाम/थर :- {{admin_name}} </p><p>पद :- {{post}} </p></div></div></div></div>",
//   "config": {
//       "isNewFormat": true,
//       "preview": 1
//   },
//   "values": [
//       {
//           "key": "FormGroup",
//           "id": "1",
//           "title": "नागरिकताको विवरण",
//           "backgroundColor": "",
//           "border": "",
//           "row": [
//               [
//                   {
//                       "key": "Number",
//                       "language": "nepali",
//                       "id": "num1",
//                       "label": "ना प्र प नं."
//                   },
//                   {
//                       "key": "Date",
//                       "id": "date1",
//                       "language": "nepali",
//                       "label": "मिति"
//                   }
//               ],
//               [
//                   {
//                       "key": "Select",
//                       "language": "nepali",
//                       "label": "कारण",
//                       "id": "select1",
//                       "options": {
//                           "1": "झुत्रो भएको",
//                           "2": "हराएको",
//                           "3": "नया ढाँचाको आवश्यक भएको"
//                       }
//                   },
//                   {
//                       "key": "Select",
//                       "language": "nepali",
//                       "label": "किसिम ",
//                       "id": "select2",
//                       "options": {
//                           "1": "वंशज",
//                           "2": "जन्मको आधार",
//                           "3": "वैवाहिक अंगीकृत",
//                           "4": "जन्म सिद्ध"
//                       }
//                   }
//               ],
//               [
//                   {
//                       "key": "Text",
//                       "language": "nepali",
//                       "id": "text14",
//                       "label": "प्रमाण-पत्र लिएको कार्यालयको नाम"
//                   }
//               ]
//           ]
//       },
//       {
//           "key": "FormGroup",
//           "id": "2",
//           "title": "व्यक्तिगत विवरण",
//           "backgroundColor": "",
//           "border": "",
//           "row": [
//               [
//                   {
//                       "key": "Name",
//                       "language": "nepali",
//                       "id": "name1"
//                   },
//                   {
//                       "key": "Name",
//                       "language": "english",
//                       "id": "name2"
//                   }
//               ],
//               [
//                   {
//                       "key": "Date",
//                       "id": "date2",
//                       "language": "nepali",
//                       "label": "जन्म मिति (बि.सं)"
//                   },
//                   {
//                       "key": "Date",
//                       "id": "date3",
//                       "language": "english",
//                       "label": "Date of birth (A.D)"
//                   }
//               ],
//               [
//                   {
//                       "key": "Select",
//                       "language": "nepali",
//                       "label": "लिङ्ग",
//                       "id": "select3",
//                       "options": {
//                           "1": "male",
//                           "2": "female",
//                           "3": "other",
//                           "": "---लिङ्ग छान्नुहोस्---"
//                       }
//                   },
//                   {
//                       "key": "Select",
//                       "language": "english",
//                       "label": "Gender",
//                       "id": "select4",
//                       "options": {
//                           "1": "male",
//                           "2": "female",
//                           "3": "other",
//                           "": "---Select gender---"
//                       }
//                   }
//               ]
//           ]
//       },
//       {
//           "key": "FormGroup",
//           "id": "3",
//           "title": "जन्मेको ठेगाना",
//           "backgroundColor": "",
//           "border": "",
//           "row": [
//               [
//                   {
//                       "key": "Text",
//                       "language": "nepali",
//                       "id": "text1",
//                       "label": "जन्म स्थान"
//                   },
//                   {
//                       "key": "Text",
//                       "language": "english",
//                       "id": "text2",
//                       "label": "Place of Birth (in block)"
//                   }
//               ],
//               [
//                   {
//                       "key": "FormGroup",
//                       "id": "2",
//                       "title": "स्थायी बासस्थान",
//                       "noBorder": true,
//                       "row": [
//                           [
//                               {
//                                   "key": "Text",
//                                   "language": "nepali",
//                                   "id": "text3",
//                                   "label": "जिल्ला"
//                               },
//                               {
//                                   "key": "Text",
//                                   "language": "nepali",
//                                   "id": "text4",
//                                   "label": ""
//                               },
//                               {
//                                   "key": "Number",
//                                   "language": "nepali",
//                                   "id": "num2",
//                                   "label": "वडा नं."
//                               }
//                           ]
//                       ]
//                   }
//               ],
//               [
//                   {
//                       "key": "FormGroup",
//                       "id": "4",
//                       "title": "Permanent Address",
//                       "noBorder": true,
//                       "row": [
//                           [
//                               {
//                                   "key": "Text",
//                                   "language": "english",
//                                   "id": "text5",
//                                   "label": "District"
//                               },
//                               {
//                                   "key": "Text",
//                                   "language": "english",
//                                   "id": "text6",
//                                   "label": ""
//                               },
//                               {
//                                   "key": "Number",
//                                   "language": "english",
//                                   "id": "num3",
//                                   "label": "Ward no"
//                               }
//                           ]
//                       ]
//                   }
//               ]
//           ]
//       },
//       {
//           "key": "FormGroup",
//           "id": "3",
//           "title": "पारिवारिक विवरण",
//           "row": [
//               [
//                   {
//                       "key": "Text",
//                       "language": "nepali",
//                       "id": "text7",
//                       "label": "बाबुको नाम, थर"
//                   },
//                   {
//                       "key": "Text",
//                       "language": "nepali",
//                       "id": "text8",
//                       "label": "बाबुको वतन"
//                   },
//                   {
//                       "key": "Select",
//                       "language": "nepali",
//                       "label": "नागरिकताको किसिम ",
//                       "id": "select5",
//                       "options": {
//                           "1": "वंशज",
//                           "2": "जन्मको आधार",
//                           "3": "वैवाहिक अंगीकृत",
//                           "4": "जन्म सिद्ध"
//                       }
//                   }
//               ],
//               [
//                   {
//                       "key": "Text",
//                       "language": "nepali",
//                       "id": "text9",
//                       "label": "आमाको नाम, थर"
//                   },
//                   {
//                       "key": "Text",
//                       "language": "nepali",
//                       "id": "text10",
//                       "label": "आमाको वतन"
//                   },
//                   {
//                       "key": "Select",
//                       "language": "nepali",
//                       "label": "नागरिकताको किसिम ",
//                       "id": "select6",
//                       "options": {
//                           "1": "वंशज",
//                           "2": "जन्मको आधार",
//                           "3": "वैवाहिक अंगीकृत",
//                           "4": "जन्म सिद्ध"
//                       }
//                   }
//               ],
//               [
//                   {
//                       "key": "Text",
//                       "language": "nepali",
//                       "id": "text11",
//                       "label": "पतिको नाम, थर"
//                   },
//                   {
//                       "key": "Text",
//                       "language": "nepali",
//                       "id": "text12",
//                       "label": "पतिको वतन"
//                   },
//                   {
//                       "key": "Select",
//                       "language": "nepali",
//                       "label": "नागरिकताको किसिम ",
//                       "id": "select7",
//                       "options": {
//                           "1": "वंशज",
//                           "2": "जन्मको आधार",
//                           "3": "वैवाहिक अंगीकृत",
//                           "4": "जन्म सिद्ध"
//                       }
//                   }
//               ]
//           ]
//       }
//   ]
// }
